export default __webpack_public_path__ + "static/media/countdown.e251e64c.svg";